// src/theme/ChartTheme.js

export const CHART_COLORS = [
  '#2563eb',
  '#059669',
  '#d97706',
  '#dc2626',
  '#7c3aed',
  '#0891b2',
  '#db2777',
  '#475569',
  '#65a30d',
  '#ea580c',
];

export const getChartColor = (index) =>
  CHART_COLORS[index % CHART_COLORS.length];
